<template>
  <div>
    <h1>Home</h1>
  </div>
</template>

<script>
import { rerouteDestinations } from '../util';

export default {
  data() {
    return {};
  },

  created() {
    const destinations = rerouteDestinations;

    const corresponding = destinations[this.$store.getters.userRole];
    this.$router.push(corresponding);
  }
};
</script>
